// Сургалт — нүүр болон сургалтын хуудсуудад давтагдах хэсгүүд (цувралын карт, "Үргэлжлүүлэн үзэх")
import React from "react";
import { Link } from "react-router-dom";
import { FiCheck, FiFileText, FiLink, FiPlay, FiVideo } from "react-icons/fi";

// <video src>-д API-ийн origin хэрэгтэй (REACT_APP_MAIN_API_URL нь .../api)
export const API_ORIGIN = (process.env.REACT_APP_MAIN_API_URL || "").replace(/\/api\/?$/, "");

// 107 → "1:47"
export const fmtDur = (sec) => {
  const s = Math.max(0, Math.round(Number(sec) || 0));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};
export const fmtMin = (sec) => Math.max(1, Math.round((Number(sec) || 0) / 60));

export const itemPath = (itemId, seriesId) => `/learning/item/${itemId}${seriesId ? `?series=${seriesId}` : ""}`;

// Төрлөөр нь дүрс, өнгө
export const KIND = {
  video: { label: "Цуврал бичлэг", icon: FiVideo, cls: "bg-primary/10 text-primary" },
  guide: { label: "Гарын авлага", icon: FiFileText, cls: "bg-blue-50 text-blue-700" },
  link: { label: "Холбоос", icon: FiLink, cls: "bg-blue-50 text-blue-700" },
};
export const seriesKind = (s) => ((s.kinds || []).includes("video") ? "video" : (s.kinds || [])[0] || "video");

export function ProgressBar({ value = 0, total = 0, className = "h-1.5", color = "bg-primary" }) {
  const pct = total ? Math.min(100, Math.round((value * 100) / total)) : 0;
  return (
    <div className={`flex-1 rounded-full bg-[#eef0f4] overflow-hidden ${className}`}>
      <div className={`h-full rounded-full ${color}`} style={{ width: `${pct}%` }} />
    </div>
  );
}

// Цувралын карт — дүрс, "N бичлэг · M мин", явц
export function SeriesCard({ s }) {
  const kind = seriesKind(s);
  const k = KIND[kind] || KIND.video;
  const complete = s.itemCount > 0 && s.done >= s.itemCount;
  const Icon = complete ? FiCheck : k.icon;
  const isVideo = kind === "video";
  const meta = isVideo
    ? `${k.label} · ${s.itemCount} бичлэг${s.durationSec ? ` · ${fmtMin(s.durationSec)} мин` : ""}`
    : k.label;

  return (
    <Link to={`/learning/${s.id}`} className="pcard flex items-center gap-3 p-3.5 text-gray-900 hover:text-gray-900">
      <span className={`h-11 w-11 rounded-xl flex items-center justify-center shrink-0 ${complete ? "bg-emerald-50 text-emerald-700" : k.cls}`}>
        <Icon size={22} />
      </span>
      <span className="flex-1 min-w-0">
        <span className={`block text-xs font-semibold ${complete ? "text-emerald-700" : isVideo ? "text-primary" : "text-blue-700"}`}>{meta}</span>
        <span className="block text-sm font-bold leading-snug mt-0.5">{s.title}</span>
        {complete ? (
          <span className="block text-xs font-semibold text-emerald-700 mt-1">{isVideo ? "Бүтэн үзсэн" : "Уншсан"}</span>
        ) : s.started > 0 ? (
          <span className="flex items-center gap-2 mt-1.5">
            <ProgressBar value={s.done} total={s.itemCount} />
            <span className="text-xs font-semibold text-gray-700">{s.done} / {s.itemCount}</span>
          </span>
        ) : (
          <span className="block text-xs text-gray-500 mt-1">{isVideo ? "Эхлээгүй" : "Уншаагүй"}</span>
        )}
      </span>
    </Link>
  );
}

// "Үргэлжлүүлэн үзэх" — big: дээр нь зурагтай том карт (desktop баруун багана)
export function ContinueCard({ c, big = false }) {
  const pct = c.durationSec ? Math.min(100, Math.round((c.lastPosition * 100) / c.durationSec)) : c.watchedPct || 0;
  const thumb = (
    <span className={`relative flex items-center justify-center overflow-hidden bg-[#1f1630] shrink-0 ${big ? "h-[150px] w-full" : "h-[60px] w-[104px] rounded-[10px]"}`}>
      <span className={`rounded-full bg-white/90 flex items-center justify-center ${big ? "h-12 w-12" : "h-7 w-7"}`}>
        <FiPlay size={big ? 20 : 12} className="text-primary fill-primary ml-0.5" />
      </span>
      <span className={`absolute inset-x-0 bottom-0 bg-white/25 ${big ? "h-[5px]" : "h-1"}`}>
        <span className="block h-full bg-primary2" style={{ width: `${pct}%` }} />
      </span>
    </span>
  );
  const time = c.durationSec ? `${fmtDur(c.lastPosition)} / ${fmtDur(c.durationSec)}` : `${pct}% үзсэн`;
  return (
    <Link to={itemPath(c.itemId, c.seriesId)}
      className={`pcard overflow-hidden text-gray-900 hover:text-gray-900 ${big ? "block" : "flex items-center gap-3 p-3"}`}>
      {thumb}
      <span className={`block min-w-0 ${big ? "px-4 py-3.5" : "flex-1"}`}>
        <span className="block text-xs font-semibold text-primary">Үргэлжлүүлэн үзэх</span>
        <span className={`block font-bold mt-0.5 truncate ${big ? "text-base" : "text-[15px]"}`}>{c.seriesTitle} · {c.title}</span>
        <span className="block text-xs text-gray-500 mt-0.5">{time}{big && c.durationSec ? "-оос үргэлжлүүлэх" : ""}</span>
      </span>
    </Link>
  );
}
